import React, { Component } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'hljd'
import styles from '../style.module.less'
import { observer, inject } from 'mobx-react'
import Chart from './Chart'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

@inject('store')
@observer
export default class extends Component {
  render() {
    const { sourceTab, changValue, source } = this.props.store

    return (
      <div className={styles.block}>
        <p className={styles.title}>
          曝光来源<Tooltip
            placement="top"
            title={'展示商家店铺总曝光量以及智优投、智推宝曝光量'}
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </p>

        <RadioGroup value={sourceTab} onChange={changValue('sourceTab')}>
          <RadioButton value="7">近7日</RadioButton>
          <RadioButton value="30">近30日</RadioButton>
          <RadioButton value="60">近60日</RadioButton>
        </RadioGroup>

        <Chart data={source} />
      </div>
    )
  }
}
